import { GetUtilAgeBracketModel } from "@factory/model/query-model-util-age-bracket";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { utilAgeBracketFormDefault } from "./form.default";
import { UtilAgeBracketFormSchema } from "./form.rule";

export const useFormDefaultUtilAgeBracket = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetUtilAgeBracketModel | undefined) => {
    return !cachedValue
      ? utilAgeBracketFormDefault
     : ({
        type: cachedValue.type,
        name: cachedValue.name,
        price: cachedValue.price,
      } as UtilAgeBracketFormSchema);
  };

  return {
    getDefault,
  };
};
